export const DefaultHumanAvatar = '/default_avatar-img.png';
